import { CardDataCollector } from './cardDataCollector';
import { CommonFieldCollector } from './commonFieldCollector';
import { SchemaCollector } from './model';
import { StaticDataCollector } from './staticDataCollector';

export const GeneralSchemaCollector: SchemaCollector = {
  collect: (schema, field, context) => {
    const collectors: SchemaCollector[] = [
      StaticDataCollector,
      CardDataCollector,
      CommonFieldCollector,
    ];
    const collector = collectors.find((collector) =>
      collector.shouldCollect(field),
    );

    if (collector) {
      collector.collect(schema, field, context);
    }
  },
  shouldCollect: (_) => {
    return true;
  },
};
